// "Link to …" lists (Sale Order, Delivery Challan, Purchase Order, GRN, invoices
// for returns, Material Issue …): show only the documents of the branch being
// worked in, like every other list.
//  - "All branches", or a company without branches → every document.
//  - Documents saved before the company had branches (no branch on them) are
//    shown in every branch, so old open orders can still be linked.
//  - The document already linked on the form always stays in the list.
// Firebase cost: nothing (filters the list already loaded).

export const activeBranchId = (activeBranch) =>
  (activeBranch && activeBranch.id && activeBranch.id !== 'all') ? activeBranch.id : null;

export const inActiveBranch = (docRow, activeBranch, keepId = null) => {
  const id = activeBranchId(activeBranch);
  if (!id || !docRow) return true;
  if (keepId && docRow.id === keepId) return true;
  return !docRow.branchId || docRow.branchId === id;
};
